(function () {
  function initCarouselImages() {
    const carousels = document.querySelectorAll('.js-carousel-images');

    carousels.forEach((carousel) => {
      if (carousel.classList.contains('is-initialized')) return;

      const splide = new Splide(carousel, {
        type: 'loop',
        autoWidth: true,
        drag: true,
        arrows: false,
        pagination: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        direction: 'ltr',
        gap: 0,

        autoScroll: {
          speed: 1 
        }
      });

      splide.mount(window.splide.Extensions);

      carousel.classList.add('is-initialized');
    });
  }

  document.addEventListener('DOMContentLoaded', initCarouselImages);
  document.addEventListener('shopify:section:load', initCarouselImages);
})();